const mvSwiper = new Swiper('.mv-swiper', {
    // Optional parameters
    loop: true,
    slidesPerView: 1.5,
    spaceBetween: 5,
    centeredSlides: true, 
  effect: "coverflow",
  coverflowEffect: {          // 追加
        rotate: 30,              // 追加 (前後のスライドの回転)
        depth: 30,             // 追加 (前後のスライドの奥行)
        stretch: 0,            // 追加 (スライド間のスペース)
        modifier: 1.3,            // 追加 (rotate・depth・stretchの値を乗算する)
        scale: 0.9,               // 追加 (前後のスライドのサイズ比率)
        slideShadows: true,    // 追加 (前後のスライド表面の影の有無)
    }, 
    autoplay: {
        delay: 60000,
    },
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });